export default __webpack_public_path__ + "static/media/logo-claude.3d8120fa.png";